// src/instrument.js
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://4b11e344ae2562b482c1ef0daac7973f@o4509248605061120.ingest.us.sentry.io/4509248606306304", // Found in Project Settings > Client Keys
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Useful for Azure environments to distinguish between staging/prod
  environment: process.env.REACT_APP_SENTRY_ENV || "production",
});